export const snakeToCamel = (str: string) =>
    str
        .toLowerCase()
        .replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''));

/**
 * @deprecated Используйте camelizeKeys из @shared/helpers для типизированного преобразования.
 */
export function keysToCamel<T>(input: T): T {
    if (Array.isArray(input)) {
        return input.map((item) => keysToCamel(item)) as unknown as T;
    }
    if (input !== null && typeof input === 'object') {
        return Object.entries(input as Record<string, unknown>).reduce((acc, [key, value]) => {
            const camelKey = snakeToCamel(key);
            acc[camelKey] = keysToCamel(value);
            return acc;
        }, {} as Record<string, unknown>) as T;
    }
    return input;
}
